import { render, staticRenderFns } from "./myorder.vue?vue&type=template&id=da65064c"
import script from "./myorder.vue?vue&type=script&lang=js"
export * from "./myorder.vue?vue&type=script&lang=js"
import style0 from "./myorder.vue?vue&type=style&index=0&id=da65064c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports